import { indexItems } from '@/mocks/homeData';

export default function IndexModule() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 font-body max-w-2xl mx-auto">
            按主题分类浏览，快速找到你感兴趣的网红黑料类型，吃瓜不迷路
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300 shrink-0">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex flex-col min-w-0 flex-1">
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </span>
                <span className="text-xs text-foreground-400 font-label mt-0.5">
                  收录 {item.count} 条
                </span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}